import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant, { Lazyload } from 'vant'
import VueGecWxJssdk from '@/plugins/weixin'
import 'vant/lib/index.css'
import '@/plugins/filter.js'
import '@/plugins/rem.js'
import animate from 'animate.css'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(animate)
Vue.use(Lazyload)
Vue.use(Vant)
Vue.use(VueGecWxJssdk)
Vue.config.productionTip = false

new Vue({ router, store, render: function (h) { return h(App) } }).$mount('#app')
